import { useMemo } from 'react';
import { UrlParams } from 'clientState/hooks/useUrlParams';
import { GeoServiceLocationsRequest } from 'clientState/hooks/useGetLocations/useGetLocations';

const createLocationsRequest = (
  params: UrlParams
): GeoServiceLocationsRequest => {
  const geoNodeIds: number[] = [];
  const iatas: string[] = [];
  Object.keys(params)
    .filter((key) => /from|to/.test(key))
    .forEach((key) => {
      const locationInfoType =
        typeof params[key] === 'number' || !isNaN(params[key])
          ? 'geoNodeIds'
          : 'iatas';
      if (locationInfoType === 'iatas') iatas.push(params[key]);
      else geoNodeIds.push(parseInt(params[key]));
    });

  return { geoNodeIds, iatas };
};

export const useGetLocationRequest = (
  urlParams: UrlParams
): GeoServiceLocationsRequest => {
  const hasURLParams = Object.keys(urlParams).length;

  return useMemo(() => {
    const defaultRequest: GeoServiceLocationsRequest = {
      geoNodeIds: [],
      iatas: [],
    };
    return hasURLParams ? createLocationsRequest(urlParams) : defaultRequest;
  }, [urlParams, hasURLParams]);
};
